import React, { useState, useCallback, useRef } from 'react';
import Popup from 'reactjs-popup';
import UploadImageBuilder from './imageCropper/uploadBuilder';
import GalleryPhoto from './imageCropper/galleryPhoto';
import { Link } from 'react-router-dom';
import UnsplashPhoto from './imageCropper/unsplashPhoto';

const UploadImagePopup = ({openModal, setOpen}) => {
  const closeModal = () => setOpen(false);
   
  const fileInputRef = useRef(null);

  const [imageSrc, setImageSrc] = useState(null);
  const [croppedImageSrc, setCroppedImageSrc] = useState("https://placehold.co/600x400.png");
  const [previewImageSrc, setPreviewImageSrc] = useState("");
  const [showImageBuilder, setShowImageBuilder] = useState(false);
  const [previewImageBuilder, setPreviewImageBuilder] = useState(false);
  const [activeTab, setActiveTab] = useState('computer'); // New state for active tab

  const onFileChange = async (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      let imageDataUrl = await readFile(file);
      setImageSrc(imageDataUrl);
      setShowImageBuilder(true);
    }
  }
  const previewCancel = () => {
    setPreviewImageBuilder(false)
    setPreviewImageSrc(null);
  }
  const previewSaved = ()  => {
    setCroppedImageSrc(previewImageSrc);
    setPreviewImageSrc(null);
    setActiveTab("computer");
    setPreviewImageBuilder(false)
    closeModal();
  };
  const closeImageBuilder = useCallback(() => {
    setShowImageBuilder(false);
    setImageSrc(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = ''; 
    }
  }, []);

  const handleCroppedImage = useCallback((croppedImage) => {
    setPreviewImageBuilder(true)
    setPreviewImageSrc(croppedImage);
    setShowImageBuilder(false);
  }, []);
  const handleGalleryImageChange = useCallback((onSelectImage) => {
    setImageSrc(onSelectImage);
    setShowImageBuilder(true);
    setPreviewImageBuilder(true)
  }, []);

  return (
    <div>
      <Popup open={openModal} onClose={closeModal} closeOnDocumentClick lockScroll={true}>
        <Link className="close-modal" onClick={closeModal}>
          &times;
        </Link>
      
        <div className="modal">
        {showImageBuilder && (
                    <UploadImageBuilder 
                    imageUrl={imageSrc} 
                    onClose={closeImageBuilder} 
                    setCroppedImageSrc={handleCroppedImage}
                    setImageSrc={setImageSrc}
                    />
                )}
        {previewImageBuilder && previewImageSrc !== null && (
            <div className="preview-image-wrapper">
                <h3>Preview image</h3>
                <div className="preview-image">
                      <img src={previewImageSrc} alt="Cropped" style={{ maxWidth: '100%' }} />
                </div>
                <div className="preview-action">
                    <button className="btn-cancel" onClick={previewCancel}>Cancel</button>
                    <button onClick={previewSaved}>Done</button>
                </div>
            </div>
        )}
          <div className="modal-header flex-column">
            <h4>Change profile picture</h4>
            <div className="uploader-tab">
              <div 
                className={`single-tab ${activeTab === 'computer' ? 'active' : ''}`}
                onClick={() => setActiveTab('computer')}
              >
                <i className="ri-macbook-line"></i>
                <span>From Computer</span>
              </div>
              <div 
                className={`single-tab ${activeTab === 'gallery' ? 'active' : ''}`}
                onClick={() => setActiveTab('gallery')}
              >
                <i className="ri-gallery-line"></i>
                <span>From Gallery</span>
              </div>
              <div 
                className={`single-tab ${activeTab === 'search' ? 'active' : ''}`}
                onClick={() => setActiveTab('search')}
              >
                <i className="ri-file-search-line"></i>
                <span>Search Photo</span>
              </div>
            </div>
          </div>
          <div className="modal-content">
            <div className="content-wrapper">
              {activeTab === 'computer' && (
                <div className="sng-photo-content">
                  <div className="upload-wrapper">
                    <div className="upload-image-wrapper">
                      <img src={croppedImageSrc} alt="Cropped" style={{ maxWidth: '100%' }} />
                    </div>
                    <label htmlFor="uploadFile">
                      <i className="ri-upload-2-line"></i>
                      <span>Upload Image</span>
                    </label>
                    <input 
                      type="file"
                      id="uploadFile"
                      onChange={onFileChange} 
                      accept="image/*" 
                      ref={fileInputRef}
                    />
                  </div>
                </div>
              )}
              {activeTab === 'gallery' && (
                <div className="sng-photo-content">
                  <GalleryPhoto setImageSrc={handleGalleryImageChange} />
                </div>
              )}
              {activeTab === 'search' && (
                <div className="sng-photo-content">
                   <UnsplashPhoto setImageSrc={handleGalleryImageChange} />
                </div>
              )}
            </div>
          </div>
        </div>
      </Popup>
    </div>
  );
};

function readFile(file) {
  return new Promise((resolve) => {
    const reader = new FileReader()
    reader.addEventListener('load', () => resolve(reader.result), false)
    reader.readAsDataURL(file)
  })
}

export default UploadImagePopup;
